<div #mainVwoDiv id="vwo">
    <div id="vwo-variant" [attr.data-variant-name]="initialVariantName"></div>
</div>